module.exports = __webpack_public_path__ + "img/MiBanco.3674f9ea.svg";